import { HStack, VStack } from "@gluestack-ui/themed";
import { LimitsAvailableSectionProps } from "./types";
import { Text } from "@repo/core/components/core/Text";
import { SaleValueInfo } from "@repo/core/components/receipt/infos/SaleValueInfo";
import { Icon } from "@repo/core/components/core/Icon";

export const LimitsAvailableSection = ({
  limiteDisponivelCompras,
  limiteDisponivelParcelado,
  limiteDisponivelParceladoMes,
  limiteDisponivelSaques,
  pontosDisponiveis
}: LimitsAvailableSectionProps) => {
  return (
    <VStack gap={16} py="$6">
      <HStack alignItems="center" gap={8}>
        <Icon name="bars-progress" size={18} />
        <Text fontWeight={600}>Limites disponíveis</Text>
      </HStack>
      <VStack
        borderRadius={8}
        borderWidth="$1"
        borderColor="$borderLight200"
        overflow="hidden"
      >
        <SaleValueInfo
          name="Disponível Rotativo"
          isCurrency={false}
          value={`R$ ${limiteDisponivelCompras}`}
        />
        <SaleValueInfo
          name="Disponível Parcelado Mẽs"
          isCurrency={false}
          value={`R$ ${limiteDisponivelParceladoMes}`}
          isGray
        />
        <SaleValueInfo
          name="Disponível Parcelado Total"
          isCurrency={false}
          value={`R$ ${limiteDisponivelParcelado}`}
        />
        <SaleValueInfo
          name="Disponível Saque"
          isCurrency={false}
          value={`R$ ${limiteDisponivelSaques}`}
          isGray
        />
        <SaleValueInfo
          name="Disp. Pontuação Fidelidade"
          isCurrency={false}
          value={`R$ ${pontosDisponiveis}`}
        />
      </VStack>
    </VStack>
  );
};
